/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1LinkTarget
 */
export interface V1LinkTarget {
    /**
     *
     */
    path: string
}

/**
 * Check if a given object implements the V1LinkTarget interface.
 */
export function instanceOfV1LinkTarget(value: object): value is V1LinkTarget {
    if (!('path' in value) || value['path'] === undefined) return false
    return true
}

export function V1LinkTargetFromJSON(json: any): V1LinkTarget {
    return V1LinkTargetFromJSONTyped(json, false)
}

export function V1LinkTargetFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1LinkTarget {
    if (json == null) {
        return json
    }
    return {
        path: json['path']
    }
}

export function V1LinkTargetToJSON(json: any): V1LinkTarget {
    return V1LinkTargetToJSONTyped(json, false)
}

export function V1LinkTargetToJSONTyped(
    value?: V1LinkTarget | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        path: value['path']
    }
}
